import React from 'react';
import { section, query } from '@jump/pages';
import TabBar from './js/TabBar';
import OfficeInfo from './js/OfficeInfo';

class OfficeTabs extends React.Component {
  state = {
    selected: 0
  };

  _handleTabChange = (idx) =>
    this.setState({ selected: idx });

  render () {

    const {
      apiKey,
      queries: {
        offices,
      }
    } = this.props;

    const {
      selected,
    } = this.state;

    return (
      <div className="c-Map">
        {offices.loaded &&
          <TabBar
            items={officeTabs(offices)}
            selected={selected}
            onTabChange={this._handleTabChange}
          />
        }

        {offices.loaded &&
          <OfficeInfo
            apiKey={apiKey}
            offices={offices.results}
            selectedIndex={selected}
          />
        }
      </div>
    );
  }
}

const officeTabs = ({ results }) => results.map((office) => ({
  title: office.name,
}));

export default section({
  name: 'officeTabs',
  component: OfficeTabs,
  queries: [
    query('offices')
  ],
});



// WEBPACK FOOTER //
// ./plugins/app/site/pagesections/officetabs/index.js